import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import BookingTimeModal from './BookingTimeModal';
import axios from "axios";
import moment from 'moment';
const Modal = ({
  show,
  setShowTk,
  confirmTKCheckOut,
  lanIndex,
  deliveryType,
  dt,
  nm,
  ph,
  addr,
  rm,
  setDeliveryPrice,
  deliveryPrice,
  subtotal,
  currencySymbol
}) => {
  //State
  const displayShow = show ? "grid" : "none";
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const { token, skipCustomerDetail, deliveryCalMethod, deliveryDisAmt, deliverySpend, weekDays, isInRoom, tkOrderAfter, startTime, endTime, company, customer } = React.useContext(UserContext);
  const { checkboxs } = React.useContext(UserContext);
  const [customerName, setCustomerName] = useState("");
  const [warningMsg, setWarningMsg] = useState(false);
  const [phone, setPhone] = useState("");
  let startT = moment().set("hour", moment(startTime).hour()).set("minute", moment(startTime).minute());
  const [bookingDate, setBookingDate] = useState(moment()
    .set("hour", startT.isAfter(moment()) ? moment(startTime).hour() : moment().hour())
    .set("minute", startT.isAfter(moment()) ? moment(startTime).minute() : moment().minute())
    .add(startT.isAfter(moment().add(tkOrderAfter, "minute")) ? 0 : tkOrderAfter, "minute").format("YYYY-MM-DD HH:mm")
    + " - " +
    moment()
      .set("hour", startT.isAfter(moment()) ? moment(startTime).hour() : moment().hour())
      .set("minute", startT.isAfter(moment()) ? moment(startTime).minute() : moment().minute())
      .add((startT.isAfter(moment().add(tkOrderAfter, "minute")) ? 5 : tkOrderAfter + 5), "minute").format("HH:mm")
  );
  const [address, setAddress] = useState("");
  const [postal, setPostal] = useState("");
  const [hasShowDelivery, setHasShowDelivery] = useState(false);
  const [unit, setUnit] = useState("");
  const [remark, setRemark] = useState("");
  const [showTime, setShowTime] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [room, setRoom] = useState("");
  const [selectCheckboxs, setSelectCheckboxs] = useState([]);
  // let checkboxs = ['要葱吗', '要辣吗', '一点点点'];
  const handleChange = (val, type) => {
    if (type == 'customerName') {
      setCustomerName(val)
    } else if (type == 'phone') {
      setPhone(val)
    } else if (type == 'address') {
      setAddress(val)
    } else if (type == 'unit') {
      setUnit(val)
    } else if (type == 'room') {
      setRoom(val);
    } else if (type == 'postal') {
      setPostal(val)
    } else if (type == 'remark') {
      setRemark(val)
    } else if (type == 'checkbox') {
      let idx = selectCheckboxs.indexOf(val);
      if (idx >= 0) {
        selectCheckboxs.splice(idx, 1);
      } else {
        selectCheckboxs.push(val);
      }
      setSelectCheckboxs(selectCheckboxs)
    } else {
      setBookingDate(val)
    }
    if (customerName != "" && phone != "" && bookingDate != "" && address != "") setWarningMsg(false);
  }

  const takeawayAddress = async (address) => {
    setWarningMsg(false);
    setErrorMsg("");

    await axios.get(`/v2/api/takeaway/address?address=${address}`, { headers: { Authorization: "Bearer " + token } })
      .then(function (response) {
        setLoading(false);
        setShowTk(false);
        confirmTKCheckOut(customerName, phone, moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf(), address, remark, selectCheckboxs, deliveryType);
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error.response);
        setErrorMsg(error.response.data.errorMsg);
      });
  };
  const calculateDeliveryFee = async (postal) => {
    let deliveryTime = moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf();

    await axios.get(`/v2/api/takeaway/postal?postal=${postal}&deliveryTime=${deliveryTime}`, { headers: { Authorization: "Bearer " + token } })
      .then(function (response) {
        setLoading(false);
        setAddress(response.data.address);
        setDeliveryPrice(response.data.deliveryFee - (subtotal >= deliverySpend ? deliveryDisAmt : 0))
        setHasShowDelivery(true);

      })
      .catch(function (error) {
        setLoading(false);
        setErrorMsg(error.response.data.errorMsg);
      });
  }
  const handleBlur = async () => {
    console.log("TRIGGER ONBLR", postal, deliveryCalMethod);
    if (postal != "" && deliveryCalMethod == 1) {
      setLoading(true);
      await calculateDeliveryFee(postal);
    }
  }
  const isCurrentTime = (bookingDate) => {
    let date = bookingDate.split(" ")[0];

    if (date == moment().format("YYYY-MM-DD")) {
      let timeS = bookingDate.split(" ")[1];
      let timeE = bookingDate.split(" ")[3];
      let timeStampStart = moment().set("hour", parseInt(timeS.split(":")[0])).set("minute", parseInt(timeS.split(":")[1]));
      let timeStampEnd = moment().set("hour", parseInt(timeE.split(":")[0])).set("minute", parseInt(timeE.split(":")[1]));
      let now = moment();
      console.log(timeS, timeE);
      if (now.isSameOrAfter(timeStampStart) && now.isSameOrBefore(timeStampEnd)) {
        return true;
      }
    }

    return false;
  }

  useEffect(() => {
    if (show) {
      if (customer && customer._id) {
        setCustomerName(customer.customerName);
        setPhone(customer.phone);
      }
      //set as default
      if (dt)
        setBookingDate(dt);
      if (nm)
        setCustomerName(nm);
      if (ph)
        setPhone(ph);
      if (addr)
        setAddress(addr);
      if (rm)
        setRoom(rm);

      //check if six hands
      if (company._id == "677ae529d90797dc89c7091a" || company._id == "5dc3b8d840dccce158e6f48d" || company._id == "6805bc98e75fb1ce8570ff56") {
        let pickUpTime = moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true);
        let blockTime = [];
        if (moment().isoWeekday() <= 3) {
          blockTime = [
            { startTime: moment().set("hour", 11).set("minute", 0), endTime: moment().set("hour", 14).set("minute", 30) },
            { startTime: moment().set("hour", 17).set("minute", 0), endTime: moment().set("hour", 19).set("minute", 30) },
          ];
        } else if (moment().isoWeekday() == 7) {

        } else {
          if (company._id == "6805bc98e75fb1ce8570ff56") {
            blockTime = [
              { startTime: moment().set("hour", 11).set("minute", 0), endTime: moment().set("hour", 14).set("minute", 30) },
              { startTime: moment().set("hour", 17).set("minute", 0), endTime: moment().set("hour", 19).set("minute", 30) },
            ];
          } else {
            blockTime = [
              { startTime: moment().set("hour", 11).set("minute", 0), endTime: moment().set("hour", 14).set("minute", 30) },
            ];
          }
        }

        let isWithin = false;
        for (let b of blockTime) {
          if (pickUpTime.isBetween(b.startTime, b.endTime)) {
            isWithin = true;
            break;
          }
        }


        if (!isWithin) {
          setBookingDate("");
        }

        //if today is off, then make it empty
        let tdy = moment().get("day");
        let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][tdy];
        if (!weekDays || weekDays.indexOf(tdyTxt) < 0 || weekDays.length == 0) {
          setBookingDate("");
          return;
        };

      } else {
        let pickUpTime = moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true);

        let tdy = moment().get("day");
        let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][tdy];
        if (!weekDays || weekDays.indexOf(tdyTxt) < 0 || weekDays.length == 0) {
          setBookingDate("");
          return;
        };
        let isWithin = false;
        if (pickUpTime.isBetween(moment(startTime), moment(endTime))) {
          isWithin = true;
        }
        if (!isWithin) {
          setBookingDate("");
        }
      }
    }
  }, [show]);

  const modalContent = () => {
    return (
      <React.Fragment key={0}>
        {isInRoom &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].roomNo + "*"}
            </ModalContentText>
            <Input value={room} onChange={(e) => { handleChange(e.target.value, 'room') }} />
          </ModelWrapper>
        }
        {!skipCustomerDetail &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].phone + "*"}
            </ModalContentText>
            <Input value={phone} onChange={(e) => { handleChange(e.target.value, 'phone') }} />
          </ModelWrapper>
        }

        {!skipCustomerDetail &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].name}
            </ModalContentText>
            <Input value={customerName} onChange={(e) => { handleChange(e.target.value, 'customerName') }} />
          </ModelWrapper>
        }
        {!isInRoom &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {(deliveryType == 0 || deliveryType == 1 ? languageContext[lanIndex].bookingTime : languageContext[lanIndex].deliveryTime) + "*"}
            </ModalContentText>
            <Input
              value={isCurrentTime(bookingDate) ? "Now" : bookingDate}
              readOnly
              onClick={() => {
                setShowTime(true);
                // document.activeElement.blur();
              }}
            />
          </ModelWrapper>
        }
        {deliveryType == 2 &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].postal + "*"}
            </ModalContentText>
            <Input value={postal} onChange={(e) => { handleChange(e.target.value, 'postal') }}
              onBlur={(e) => { handleBlur(e.target.value) }}
            />
          </ModelWrapper>
        }
        {deliveryType == 2 &&
          <React.Fragment>
            <ModelWrapper>
              <ModalContentText
                fontWeight={400}
                color={"black"}
              >
                {languageContext[lanIndex].unitNo + "*"}
              </ModalContentText>
              <Input value={unit} onChange={(e) => { handleChange(e.target.value, 'unit') }} />
            </ModelWrapper>
            <ModelWrapper>
              <ModalContentText
                fontWeight={400}
                color={"black"}
              >
                {languageContext[lanIndex].address + "*"}
              </ModalContentText>
              <Input value={address} onChange={(e) => { handleChange(e.target.value, 'address') }} />
            </ModelWrapper>
            {deliveryCalMethod == 1 && hasShowDelivery &&
              <ModalContentText style={{ marginTop: '10px' }} >
                {`${languageContext[lanIndex].deliveryFee}: ${currencySymbol} ${deliveryPrice}`}
              </ModalContentText>
            }
            <ModelWrapper>
              <ModalContentText
                fontWeight={400}
                color={"black"}
              >
                {languageContext[lanIndex].remark}
              </ModalContentText>
              <Input value={remark} onChange={(e) => { handleChange(e.target.value, 'remark') }} />
            </ModelWrapper>
          </React.Fragment>
        }
        <ModelWrapper style={{ padding: 0, marginBottom: '15px' }}>
          {
            checkboxs != null && checkboxs && checkboxs.map((item, index) => (
              <ModelWrapper key={index} style={{ display: 'flex', marginTop: 10 }}>
                <Checkbox type={"checkbox"} onChange={() => { handleChange(item, 'checkbox') }} />
                <ModalText>{item}</ModalText>
              </ModelWrapper>
            ))
          }
        </ModelWrapper>

      </React.Fragment>
    );

  };

  const modalButton = () => {
    return (
      <ModalButtonContainer>
        <ModalConfirmButton
          themeContext={themeContext}
          onClick={() => {
            setShowTk(false);
            setWarningMsg(false);
          }}
        >
          <ModalText
            fontSize={20}
            fontWeight={600}
            color={themeContext.fontPrimary}
          >
            {languageContext[lanIndex].cancel}
          </ModalText>
        </ModalConfirmButton>
        <ModalConfirmButton
          themeContext={themeContext}
          backgroundColor={themeContext.fontPrimary}
          onClick={() => {
            if (!skipCustomerDetail && (phone == "" || phone.trim() == "" || phone.trim().length < 8 || (!isInRoom && bookingDate == ""))) {
              setWarningMsg(true);
              return;
            }
            if (!isInRoom && bookingDate == "") {
              setWarningMsg(true);
              return;
            }
            if (isInRoom && (room == "" || room.trim() == "" || room.length < 3)) {
              setWarningMsg(true);
              return;
            }
            if (deliveryType == 2) {
              if (deliveryCalMethod == 1 && !hasShowDelivery) {
                setShowTk(false);
                setWarningMsg(true);
                return;
              }
              if (address == "") {
                setWarningMsg(true);
                return;
              }
              if (unit == "") {
                setWarningMsg(true);
                return;
              }
              if (postal == "") {
                setWarningMsg(true);
                return;
              }
              let add = "";
              if (deliveryCalMethod == 1) {
                add = address + ", " + unit + ", " + "Singapore " + postal;
              } else {
                add = unit + ", " + address + ", " + postal;
              }
              setLoading(true)
              if (deliveryCalMethod == 0) {
                takeawayAddress(add)
              } else {
                setLoading(false);
                setShowTk(false);
                confirmTKCheckOut(customerName, phone, moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf(), add, remark, selectCheckboxs, deliveryType, room);

              }
            } else {
              setShowTk(false);
              setWarningMsg(false);
              confirmTKCheckOut(customerName, phone, moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf(), address, remark, selectCheckboxs, deliveryType, room);
            }
          }}
        >
          <ModalText
            fontSize={20}
            fontWeight={600}
            color="#fff"
          >
            {languageContext[lanIndex].ok}
          </ModalText>
        </ModalConfirmButton>
      </ModalButtonContainer>
    );
  }

  return (
    <ModalContainer display={displayShow}>
      <ModalMain themeContext={themeContext} height={deliveryType == 0 || deliveryType == 1 ? 430 : 500}>
        <ModalContent themeContext={themeContext}>
          {warningMsg &&
            <ModalContentText
              textAlign={"center"}
              fontWeight={400}
              color={"red"}
            >
              {isInRoom ? languageContext[lanIndex].selectRoomWarning : (deliveryType == 0 || deliveryType == 1 ? languageContext[lanIndex].selectDateWarning : languageContext[lanIndex].selectDateWarning1)}
            </ModalContentText>
          }
          {errorMsg && errorMsg != '' &&
            <ModalContentText
              textAlign={"center"}
              fontWeight={400}
              color={"red"}
            >
              {errorMsg}
            </ModalContentText>
          }
          {modalContent()}
        </ModalContent>
        {modalButton()}
      </ModalMain>
      <BookingTimeModal show={showTime} setShowTime={setShowTime} changeBookingTime={handleChange} lanIndex={lanIndex} deliveryType={deliveryType} />
      {loading && <Loading>
        <LoadingMain>
          <svg t="1659085231731" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9459" width="50" height="50"><path d="M298.666667 142.498133m-73.900835 42.666667a85.333333 85.333333 0 1 0 147.801669-85.333333 85.333333 85.333333 0 1 0-147.801669 85.333333Z" p-id="9460" fill="#f3962b"></path><path d="M142.498133 298.666667m-42.666666 73.900834a85.333333 85.333333 0 1 0 85.333333-147.801669 85.333333 85.333333 0 1 0-85.333333 147.801669Z" p-id="9461" fill="#f3962b"></path><path d="M85.333333 512m0 85.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 1 0 0 170.666666Z" p-id="9462" fill="#f3962b"></path><path d="M142.498133 725.333333m42.666667 73.900835a85.333333 85.333333 0 1 0-85.333333-147.801669 85.333333 85.333333 0 1 0 85.333333 147.801669Z" p-id="9463" fill="#f3962b"></path><path d="M298.666667 881.501867m73.900834 42.666666a85.333333 85.333333 0 1 0-147.801669-85.333333 85.333333 85.333333 0 1 0 147.801669 85.333333Z" p-id="9464" fill="#f3962b"></path><path d="M512 938.666667m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" p-id="9465" fill="#f3962b"></path><path d="M725.333333 881.501867m-73.900834 42.666666a85.333333 85.333333 0 1 0 147.801669-85.333333 85.333333 85.333333 0 1 0-147.801669 85.333333Z" p-id="9466" fill="#f3962b"></path><path d="M881.501867 725.333333m-42.666667 73.900835a85.333333 85.333333 0 1 0 85.333333-147.801669 85.333333 85.333333 0 1 0-85.333333 147.801669Z" p-id="9467" fill="#f3962b"></path><path d="M938.666667 512m0 85.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 1 0 0 170.666666Z" p-id="9468" fill="#f3962b"></path><path d="M881.501867 298.666667m42.666666 73.900834a85.333333 85.333333 0 1 0-85.333333-147.801669 85.333333 85.333333 0 1 0 85.333333 147.801669Z" p-id="9469" fill="#f3962b"></path><path d="M725.333333 142.498133m73.900835 42.666667a85.333333 85.333333 0 1 0-147.801669-85.333333 85.333333 85.333333 0 1 0 147.801669 85.333333Z" p-id="9470" fill="#f3962b"></path><path d="M512 85.333333m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" p-id="9471" fill="#f3962b"></path></svg>
        </LoadingMain>
      </Loading>}
    </ModalContainer>
  );
};

export default Modal;

const ModalContainer = styled.div`
  display: ${(props) => props.display};
  position: fixed;
  place-content: center;
  top: 0;

  width: 100vw;
  max-width: 550px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
`;

const ModalMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 5px;
  position: relative;

  max-height: 62vh;
  font-family: ${(props) => props.themeContext.fontFamily};
  background: #fff;
  z-index: 10;
  padding: 20px;
`;
const ModelWrapper = styled.div`
  text-align: left;
 
`;
const ModalContent = styled.div`
  color: ${(props) => props.themeContext.fontPrimary};
  display: flex;
  flex-direction: column;
  overflow: scroll;
  text-align: ${(props) => (props.error ? "left" : "center")};
  align-items: center;
  margin-top: 0px;
`;
const ModalButtonContainer = styled.div`
  margin-top: 12px;
  display: flex;
  width: 100%;
`;

const ModalConfirmButton = styled.div`
  flex: 1;
  background-color: ${(props) => props.backgroundColor};
  margin: 2%;
  margin-bottom: 0;
  padding: 5px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  place-content: center;
  border-radius: 6px;
  border: 2px solid;
  border-color: ${(props) => props.themeContext.fontPrimary};
`;

const ModalContentText = styled.div`
  margin-bottom: 6px;
  color: ${(props) => (props.color ? props.color : "black")};
  font-size: 16px;
  font-weight: ${(props) => props.fontWeight};
  line-height: 18px;
`;

const ModalText = styled.span`
  align-self: center;
  justify-content: center;
  text-align: ${(props) => (props.textAlign ? props.textAlign : "left")};
  color: ${(props) => (props.color ? props.color : "black")};
  font-size: ${(props) => props.fontSize}px;
  font-weight: ${(props) => props.fontWeight};
  padding-left: ${(props) => (props.margin ? props.margin : 0)}px;
  padding-right: ${(props) => (props.margin ? props.margin : 0)}px;
`;

const InputText = styled.div`
  height: 30px;
  border-radius: 4px;
  padding-left: 16px;
  font-size: 16px;
  border: 1px solid #aaa;
  margin-bottom: 10px;
`;
const Input = styled.input`
  height: 30px;
  border-radius: 4px;
  padding-left: 16px;
  font-size: 16px;
  border: 1px solid #aaa;
  margin-bottom: 10px;
  
`;

const Loading = styled.div`
  position: fixed;
  top: 0;

  width: 100vw;
  max-width: 550px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  z-index: 12;
`;

const LoadingMain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  max-width: 550px;
  height: 100vh;
  transform: rotate(0deg);
  // animation: mymove 1.6s infinite;
  // animation-timing-function: linear;
  // @keyframes mymove {
  //   0% {
  //     transform: rotate(0deg);
  //   }
  //   50% {
  //     transform: rotate(180deg);
  //   }
  //   100% {
  //     transform: rotate(360deg);
  //   }
  // }
`;

const Checkbox = styled.input`
  height: 20px;
  width: 20px;
  margin: 5px 15px 5px 5px;
`